import * as React from 'react';
import classNames from 'classnames';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

import styles from './CustomTooltipInfo.module.scss';
import Icon from '../Icon';
import Overlay from '../Overlay';
import Text from '../Text';

export interface Props
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'content'> {
  info?: string;
  content?: React.ReactNode;
}

const CustomTooltipInfo: React.FunctionComponent<Props> = ({
  className,
  info,
  content,
  ...htmlProps
}) => {
  const [show, setShow] = React.useState(false);
  const btnRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <span
      className={classNames('d-flex', className)}
      ref={btnRef}
      {...htmlProps}
    >
      <Icon
        icon={faInfoCircle}
        color="primary"
        onMouseOver={() => setShow(true)}
        onMouseOut={() => setShow(false)}
      />

      <Overlay
        show={show}
        placement="bottom-start"
        target={btnRef.current}
        onHide={() => setShow(false)}
        tooltip
      >
        <div className={classNames(styles.tooltip)} role="tooltip">
          <div className="d-flex flex-column gap-2">
            {info && (
              <Text as="span" size="sm2">
                {info}
              </Text>
            )}
            {content}
          </div>
        </div>
      </Overlay>
    </span>
  );
};

export default CustomTooltipInfo;
